import { LoaderFunctionArgs } from 'react-router-dom'

import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const settingsJourneyRoutes = [
  {
    id: 'settings-email-add',
    trackingName: 'Settings Email Add',
    path: 'web/view/settings/email/add',
    lazy: async () => ({
      Component: (await import('../components/JourneySettingsEmailAdd')).JourneySettingsEmailAdd,
    }),
  },
  {
    id: 'settings-phone-number-add',
    trackingName: 'Settings Phone Number Add',
    path: 'web/view/settings/phone/add',
    lazy: async () => ({
      Component: (await import('../components/JourneySettingsPhoneNumberAdd')).JourneySettingsPhoneNumberAdd,
    }),
  },
  {
    id: 'add-cashtag',
    trackingName: 'Add Cashtag',
    path: 'web/view/add-cashtag',
    lazy: async () => ({
      Component: (await import('../components/JourneyCashtag')).JourneyCashtag,
      props: { isEditing: false },
    }),
  },
  {
    id: 'edit-cashtag',
    trackingName: 'Edit Cashtag',
    path: 'web/view/edit-cashtag',
    lazy: async () => ({
      Component: (await import('../components/JourneyCashtag')).JourneyCashtag,
      props: { isEditing: true },
    }),
  },
  {
    id: 'remove-instrument',
    trackingName: 'Remove Instrument',
    path: 'web/view/settings/instrument/remove/:instrumentToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyRemoveInstrument')).JourneyRemoveInstrument,
    }),
  },
  {
    id: 'settings-disable-security-lock',
    trackingName: 'Disable Security Lock',
    path: 'web/view/settings/security-lock/disable',
    lazy: async () => ({
      Component: (await import('../components/JourneyUnlockSecurityLock')).JourneyUnlockSecurityLock,
    }),
  },
  {
    id: 'settings-link-instrument',
    trackingName: 'Link Instrument',
    path: 'web/view/settings/instrument/link/:instrumentType',
    lazy: async () => ({
      Component: (await import('../components/JourneyLinkInstrument')).JourneyLinkInstrument,
    }),
  },
  {
    id: 'settings-relink-instrument',
    trackingName: 'ReLink Instrument',
    path: 'web/view/settings/instrument/relink/:instrumentType',
    lazy: async () => ({
      Component: (await import('../components/JourneyLinkInstrument')).JourneyReLinkInstrument,
    }),
  },
  {
    id: 'settings-view-limits',
    trackingName: 'View Limits',
    path: 'dl/view/limits',
    loader: async ({ context }: LoaderFunctionArgs) => {
      context.browserNavigate('/settings#limits', { appName: 'account' })
      return null
    },
  },
  {
    id: 'settings-view-pin',
    trackingName: 'View Pin',
    path: 'dl/view/pin',
    loader: async ({ context }: LoaderFunctionArgs) => {
      context.browserNavigate('/settings#security', { appName: 'account' })
      return null
    },
  },
] as const satisfies JourneyRoute[]
